import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

export type AiChatPageContext = {
    route: string;
    customerId?: string;
    serviceId?: string;
};

@Injectable({ providedIn: 'root' })
export class AiChatPageContextService {
    private readonly router = inject(Router);

    current(): AiChatPageContext {
        const route = this.router.url;
        let customerId: string | undefined;
        let serviceId: string | undefined;

        let snapshot = this.router.routerState.snapshot.root;
        while (snapshot.firstChild != null) {
            snapshot = snapshot.firstChild;
            const params = snapshot.params;
            if (params['customerId'] != null) {
                customerId = params['customerId'];
            }
            if (params['serviceId'] != null) {
                serviceId = params['serviceId'];
            }
        }

        return { route, customerId, serviceId };
    }
}
